<script setup>
import { onMounted, ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';

defineProps({
  videoId: {
    type: String,
    required: true,
  },
  videoSrc: {
    type: String,
    required: true,
  },
  posterSrc: {
    type: String,
    default: '',
  },
  sourceType: {
    type: String,
    default: 'video/mp4',
  },
  isLoop: {
    type: Boolean,
    default: false,
  },
  additionalClasses: {
    type: String,
    default: '',
  },
  hasMediaOverlay: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const mediaWrapper = ref(null);
const media = ref(null);
const isPlaying = ref(true);

const mediaControlLabel = computed(() =>
  isPlaying.value ? t('Accessibility.videoPlay') : t('Accessibility.videoPause'),
);

onMounted(() => {
  if (mediaWrapper.value) {
    new Toolkit.SGPHXBackgroundVideo(mediaWrapper.value);

    media.value.addEventListener('play', () => {
      isPlaying.value = true;
    });
    media.value.addEventListener('pause', () => {
      isPlaying.value = false;
    });
  }
});
</script>

<template>
  <div :id="videoId" ref="mediaWrapper" class="background-video sgphx-video-player" :class="additionalClasses">
    <video
      ref="media"
      class="background-video__video"
      :poster="posterSrc"
      autoplay
      muted
      playsinline
      :loop="isLoop"
      aria-hidden="true"
    >
      <source :data-src="videoSrc" :type="sourceType" />
    </video>

    <button class="background-video__controls" type="button" :aria-label="mediaControlLabel">
      <slot></slot>
    </button>

    <div class="loader background-video__loader"></div>

    <div v-if="hasMediaOverlay" class="media-overlay"></div>
  </div>
</template>
